(function () {
  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function initCasaProduct(root) {
    if (!root || root.dataset.casaReady === 'true') return;
    root.dataset.casaReady = 'true';

    var gallery = root.querySelector('[data-casa-gallery]');
    var slides = gallery ? Array.from(gallery.querySelectorAll('[data-casa-slide]')) : [];
    var thumbs = gallery ? Array.from(gallery.querySelectorAll('[data-casa-thumb]')) : [];
    var track = gallery && gallery.querySelector('[data-casa-gallery-track]');
    var counter = gallery && gallery.querySelector('[data-casa-gallery-current]');
    var activeIndex = Math.max(
      0,
      slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      })
    );

    function updateGalleryState(index, shouldScroll) {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === activeIndex);
        thumb.setAttribute('aria-current', thumbIndex === activeIndex ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(activeIndex + 1);

      var activeThumb = thumbs[activeIndex];
      if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });

      if (shouldScroll && window.matchMedia('(max-width: 989px)').matches && slides[activeIndex]) {
        slides[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    function showMediaById(mediaId) {
      if (!mediaId) return;
      var index = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId) === String(mediaId);
      });
      if (index >= 0) updateGalleryState(index, true);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        updateGalleryState(index, true);
      });
    });

    var previousButton = gallery && gallery.querySelector('[data-casa-gallery-prev]');
    var nextButton = gallery && gallery.querySelector('[data-casa-gallery-next]');
    if (previousButton) previousButton.addEventListener('click', function () { updateGalleryState(activeIndex - 1, false); });
    if (nextButton) nextButton.addEventListener('click', function () { updateGalleryState(activeIndex + 1, false); });

    if (track && slides.length > 1) {
      var scrollFrame;
      track.addEventListener(
        'scroll',
        function () {
          if (!window.matchMedia('(max-width: 989px)').matches) return;
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(function () {
            var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            if (index !== activeIndex) updateGalleryState(index, false);
          });
        },
        { passive: true }
      );
    }

    var variantDataElement = root.querySelector('[data-casa-variant-json]');
    var variants = [];
    if (variantDataElement) {
      try {
        variants = JSON.parse(variantDataElement.textContent);
      } catch (error) {
        console.error('Casa silp variant data could not be parsed.', error);
      }
    }

    var optionGroups = Array.from(root.querySelectorAll('.casa-option'));
    var optionInputs = Array.from(root.querySelectorAll('[data-casa-option-input]'));
    var variantIdInput = root.querySelector('[data-casa-variant-id]');
    var priceElement = root.querySelector('[data-casa-price]');
    var compareElement = root.querySelector('[data-casa-compare-price]');
    var saleBadge = root.querySelector('[data-casa-sale-badge]');
    var addButton = root.querySelector('.casa-add-button');
    var addLabel = root.querySelector('[data-casa-add-label]');
    var quantityInput = root.querySelector('[data-casa-quantity]');
    var packButtons = Array.from(root.querySelectorAll('[data-casa-pack]'));
    var currency = root.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var defaultAddLabel = addLabel ? addLabel.textContent.trim() : 'Add to cart';

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var checked = group.querySelector('[data-casa-option-input]:checked');
        return checked ? checked.value : '';
      });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return String(option) === String(options[index]);
        });
      });
    }

    function syncOptionAvailability() {
      var selected = selectedOptions();
      optionGroups.forEach(function (group, groupIndex) {
        Array.from(group.querySelectorAll('[data-casa-option-input]')).forEach(function (input) {
          var canSelect = variants.some(function (variant) {
            if (!variant.available || String(variant.options[groupIndex]) !== String(input.value)) return false;
            return variant.options.every(function (option, optionIndex) {
              return optionIndex === groupIndex || !selected[optionIndex] || String(option) === String(selected[optionIndex]);
            });
          });
          input.classList.toggle('is-disabled', !canSelect);
          input.setAttribute('aria-disabled', canSelect ? 'false' : 'true');
        });
      });
    }

    function updatePackPrices(variant) {
      packButtons.forEach(function (button) {
        var quantity = Number(button.dataset.quantity || 1);
        var price = button.querySelector('[data-casa-pack-price]');
        var compare = button.querySelector('[data-casa-pack-compare]');
        if (price) price.textContent = formatMoney(variant.price * quantity, currency);
        if (compare) {
          var hasCompare = Number(variant.compare_at_price) > Number(variant.price);
          compare.classList.toggle('is-hidden', !hasCompare);
          compare.textContent = hasCompare ? formatMoney(variant.compare_at_price * quantity, currency) : '';
        }
      });
    }

    function updateQuantityRules(variant) {
      if (!quantityInput || !variant) return;
      var selectedPackButton = root.querySelector('[data-casa-pack].is-selected');
      var packQuantity = Number(selectedPackButton ? selectedPackButton.dataset.quantity : 1);
      var min = Number(variant.quantity_min || 1);
      var increment = Number(variant.quantity_increment || 1);
      var requested = Math.max(packQuantity, min);
      quantityInput.min = String(min);
      quantityInput.step = String(increment);
      if (variant.quantity_max) quantityInput.max = String(variant.quantity_max);
      else quantityInput.removeAttribute('max');
      quantityInput.value = String(requested);
    }

    function setUnavailable(message) {
      if (variantIdInput) variantIdInput.value = '';
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = message || (window.variantStrings && variantStrings.unavailable) || 'Unavailable';
    }

    function updateVariant(variant, updateUrl) {
      if (!variant) {
        setUnavailable();
        syncOptionAvailability();
        return;
      }

      if (variantIdInput) {
        variantIdInput.value = String(variant.id);
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceElement) priceElement.textContent = formatMoney(variant.price, currency);

      var hasCompare = Number(variant.compare_at_price) > Number(variant.price);
      if (compareElement) {
        compareElement.classList.toggle('is-hidden', !hasCompare);
        compareElement.textContent = hasCompare ? formatMoney(variant.compare_at_price, currency) : '';
      }
      if (saleBadge) saleBadge.classList.toggle('is-hidden', !hasCompare);

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available
          ? defaultAddLabel
          : (window.variantStrings && variantStrings.soldOut) || 'Sold out';
      }

      optionGroups.forEach(function (group, index) {
        var selectedValue = group.querySelector('[data-casa-selected-option]');
        if (selectedValue) selectedValue.textContent = variant.options[index] || '';
      });

      updatePackPrices(variant);
      updateQuantityRules(variant);
      syncOptionAvailability();
      showMediaById(variant.featured_media_id);

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = findVariant(selectedOptions());
        updateVariant(variant, true);
      });
    });

    packButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        packButtons.forEach(function (item) {
          item.classList.toggle('is-selected', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        if (quantityInput) quantityInput.value = String(button.dataset.quantity || 1);
      });
    });

    var selectedPack = root.querySelector('[data-casa-pack].is-selected') || packButtons[0];
    if (selectedPack) selectedPack.click();

    var initialVariant = variants.find(function (variant) {
      return variantIdInput && String(variant.id) === String(variantIdInput.value);
    });
    if (initialVariant) updateVariant(initialVariant, false);

    var careModal = root.querySelector('[data-casa-care-modal]');
    var careOpen = root.querySelector('[data-casa-care-open]');
    var careCloseButtons = careModal ? Array.from(careModal.querySelectorAll('[data-casa-care-close]')) : [];
    var previousFocus;

    function closeCareModal() {
      if (!careModal) return;
      careModal.hidden = true;
      document.body.classList.remove('casa-modal-open');
      if (previousFocus) previousFocus.focus();
    }

    if (careOpen && careModal) {
      careOpen.addEventListener('click', function () {
        previousFocus = document.activeElement;
        careModal.hidden = false;
        document.body.classList.add('casa-modal-open');
        var closeButton = careModal.querySelector('.casa-care-modal__close');
        if (closeButton) closeButton.focus();
      });
      careCloseButtons.forEach(function (button) {
        button.addEventListener('click', closeCareModal);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !careModal.hidden) closeCareModal();
      });
    }

    var reviewsLink = root.querySelector('[data-casa-scroll-reviews]');
    if (reviewsLink) {
      reviewsLink.addEventListener('click', function (event) {
        var reviews = document.querySelector('.casa-reviews');
        if (!reviews) return;
        event.preventDefault();
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function initRecommendations(root) {
    if (!root || root.dataset.casaRecommendationsReady === 'true') return;
    root.dataset.casaRecommendationsReady = 'true';
    var url = root.dataset.url;
    if (!url || root.querySelector('.casa-recommendations__grid')) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var replacement = html.querySelector('[data-casa-recommendations]');
        if (replacement && replacement.innerHTML.trim()) root.innerHTML = replacement.innerHTML;
      })
      .catch(function (error) {
        console.error('Casa recommendations could not be loaded.', error);
      });
  }

  function initReviews(root) {
    if (!root || root.dataset.casaReviewsReady === 'true') return;
    root.dataset.casaReviewsReady = 'true';
    var cards = Array.from(root.querySelectorAll('[data-casa-review-card]'));
    var filters = Array.from(root.querySelectorAll('[data-casa-review-filter]'));
    var loadMore = root.querySelector('[data-casa-reviews-more]');
    var initialCount = Number(root.dataset.initialCount || 4);
    var visibleCount = initialCount;
    var activeFilter = 'all';

    function matches(card) {
      if (activeFilter === 'all') return true;
      if (activeFilter === 'photos') return card.dataset.hasPhoto === 'true';
      return card.dataset.rating === activeFilter;
    }

    function render() {
      var matchedIndex = 0;
      var totalMatched = 0;
      cards.forEach(function (card) {
        if (!matches(card)) {
          card.hidden = true;
          return;
        }
        totalMatched += 1;
        card.hidden = matchedIndex >= visibleCount;
        matchedIndex += 1;
      });
      if (loadMore) loadMore.hidden = totalMatched <= visibleCount;
    }

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        activeFilter = filter.dataset.casaReviewFilter;
        visibleCount = initialCount;
        filters.forEach(function (item) { item.classList.toggle('is-active', item === filter); });
        render();
      });
    });

    if (loadMore) {
      loadMore.addEventListener('click', function () {
        visibleCount += initialCount;
        render();
      });
    }

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-casa-product]').forEach(initCasaProduct);
    (scope || document).querySelectorAll('[data-casa-recommendations]').forEach(initRecommendations);
    (scope || document).querySelectorAll('[data-casa-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
